import { Stack, Typography, useMediaQuery } from "@mui/material";
import React, { useEffect, useState } from "react";
import { colors } from "../../theme/theme";
import moment from "moment/moment";
import { CustomBtn } from "../Common/CustomBtn";
import MessageIcon from "@mui/icons-material/Message";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { ErrorSnackbar } from "../Common/CustomSnackbar";
import { UpgradeOutlined } from "@mui/icons-material";

const CreatorInfo = ({ userData, onMessageClick, isSelf, isAdmin }) => {
  const navigate = useNavigate();
  const mediumScreen = useMediaQuery("(max-width:960px)");
  const smallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const { userData: currentUser } = useSelector((state) => state.user);
  const [errorState, setErrorState] = useState({
    error: false,
    message: "",
  });

  const handleMessageClick = () => {
    const creatorId = userData?.id;
    const subscription = currentUser?.subscribed?.find(
      (sub) => sub.creatorId === creatorId
    );

    if (subscription) {
      navigate(`/chat/${userData?.id}`, { state: { userData } });
    } else {
      setErrorState({
        error: true,
        message: "Current Subscription package does not include messaging.",
      });
    }
  };

  return (
    <Stack
      direction={smallScreen ? "column" : mediumScreen ? "column" : "row"}
      sx={{
        mt: 5,
        gap: smallScreen ? 2 : mediumScreen ? 3 : 6,
        alignItems: smallScreen ? "center" : "flex-start",
        textAlign: smallScreen ? "center" : "left",
      }}
    >
      <ErrorSnackbar
        error={errorState.error}
        handleCloseError={() => setErrorState({ error: false, message: "" })}
        errorMsg={errorState.message}
      />
      {/* User Avatar */}
      <img
        src={userData?.avatar || require("../../assets/images/user.jpg")}
        alt="avatar"
        style={{
          width: smallScreen ? "80px" : mediumScreen ? "100%" : "200px",
          height: smallScreen ? "80px" : mediumScreen ? "400px" : "200px",
          objectFit: "cover",
          borderRadius: "50%", // Making it circular
        }}
      />

      {/* User Info and Message Button */}
      <Stack
        sx={{
          gap: 1,
          justifyContent: "center",
          alignItems: smallScreen ? "center" : "flex-start",
          flexGrow: 1,
        }}
        direction={"column"}
      >
        {/* User Details */}
        <Typography
          sx={{
            color: "#000",
            fontSize: smallScreen ? "24px" : "32px",
            fontFamily: "Inter-Bold",
          }}
        >
          {userData?.firstName} {userData?.lastName}
        </Typography>
        <Typography
          sx={{
            fontFamily: "Inter-Regular",
            color: colors.textColor,
            fontSize: "14px",
            textTransform: "uppercase",
          }}
        >
          Date joining{" "}
          <Typography
            component={"span"}
            sx={{
              fontFamily: "Inter-Medium",
              color: colors.primary,
              fontSize: "14px",
              textTransform: "uppercase",
            }}
          >
            {moment(userData?.createdAt).format("MMMM DD, YYYY")}
          </Typography>
        </Typography>

        {userData?.bio && (
          <Typography
            sx={{
              color: "#00000099",
              fontSize: "16px",
              fontFamily: "Inter-Regular",
              maxWidth: smallScreen ? "90%" : "80%",
            }}
          >
            {userData?.bio}
          </Typography>
        )}

        {/* Message Button */}

        {isSelf && userData.messagingEnabled && !isAdmin && (
          <CustomBtn
            text="Message"
            Icon={MessageIcon}
            width={smallScreen ? "100%" : "auto"}
            onClick={handleMessageClick}
          />
        )}

        {!isSelf && !userData.creatorId && (
          <CustomBtn
            text="Become a Creator"
            Icon={UpgradeOutlined}
            width={smallScreen ? "100%" : "auto"}
            onClick={() => {
              navigate("/creator/form", {
                state: {
                  isFreshlyRegistered: false,
                },
              });
            }}
          />
        )}
      </Stack>
    </Stack>
  );
};

export default CreatorInfo;
